var viewer_figure_rtlignore_default = {
  "figure": "X8uJN"
};
export {
  viewer_figure_rtlignore_default as default
};
//# sourceMappingURL=viewer-figure.rtlignore-scss.js.map
